import isNil from "lodash/fp/isNil";
import isEmpty from "lodash/fp/isEmpty";
class Controller {
  constructor(
    $injector,
    $state,
    $stateParams,
    $mdDialog,
    Events,
    settledInvoice
  ) {
    "ngInject";

    this.$mdDialog = $mdDialog;
    this.settledInvoice = settledInvoice;
    this.isUploading = false;
    this.errorEvent = Events.eventsType.onShowErrorNotification;
    this.showNotificationEvent = Events.eventsType.showNotificationEvent;
    this.$stateParams = $stateParams;
    this.$state = $state;
    this.Corporate = $injector.get("Corporate");
    this.Events = Events;
  }
  $onInit() {}

  confirm() {
    this.settle();
  }

  clear() {
    delete this.settledInvoice.document;
  }

  validateSettlement(settledInvoice) {
    const hasDescription =
      (typeof settledInvoice.description !== "string" &&
        isNil(settledInvoice.description)) ||
      isEmpty(settledInvoice.description);
    const hasDocument = isNil(settledInvoice.document);
    return hasDescription || hasDocument;
  }

  settle() {
    if (this.settledInvoice.document) {
      this.isUploading = true;
      const data = {
        document: this.settledInvoice.document,
        note: this.settledInvoice.description,
      };

      this.Corporate.uploadSettlement(this.$stateParams.id, {
        ...data,
      }).$promise.then(
        () => {
          this.Events.emit(this.showNotificationEvent, {
            message: "Your file has been uploaded successfully",
          });
          this.isUploading = false;
          delete this.settledInvoice.document;
          this.$mdDialog.hide();
          this.navigateToCorporate();
        },
        (response) => {
          const message = response.data.message || "Can't upload your file !";

          this.Events.emit(this.errorEvent, { message });
          this.isUploading = false;
        }
      );
    }
  }

  close() {
    this.$mdDialog.cancel();
  }

  navigateToCorporate() {
    this.$state.transitionTo(
      "corporateinvoice",
      { id: this.$stateParams.id },
      { reload: true }
    );
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/corporateInvoice/settlementDialog/settlementDialog.controller.js